import React, { useState } from 'react';
import classNames from 'classnames';

import styles from './assets/seance-actions.module.scss';
import { faCheck, faMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import AmountLogs from './AmountLogs';
interface Props {
    original: any;
    data: any;
    setData: any;
    paymentId: undefined | number | string;
    name: string;
    amountValue: number;
    changeValue: (field: string, value: string | null) => void;
}

const SeanceActionsColumn: React.FunctionComponent<Props> = ({
    original,
    changeValue,
    data,
    setData,
    name,
    paymentId,
    amountValue,
}) => {
    const idValue = data[`${original?.id}`];
    const [checkValue, setCheckValue] = useState<number>(+!!idValue?.checkValue);
    const [valueState, setValue] = useState<string>(idValue?.[`${name}`]);
    const [err, setErr] = useState<string>('');
    const logs: any = [];
    let total = 0;
    if (original.paymentInvoices) {
        original.paymentInvoices.forEach((itP: any) => {
            if (paymentId && +itP.status === 1) {
                if (+itP.payment?.id !== +paymentId || (+itP.payment?.id === +paymentId && itP.paymentCredit)) {
                    logs.push(itP);
                    total += itP?.amount ? +itP?.amount : 0;
                }
            }
        });
    }
    total += valueState ? +valueState : 0;
    const handleSave = () => {
        if (+original.invoiceTotal < +total || amountValue < +valueState) {
            setErr('Amount more then Invoice Total!');
            setCheckValue(0);
        } else {
            changeValue('some', '22');
            setData({
                ...data,
                [`${original?.id}`]: {
                    ...idValue,
                    checkValue: 1,
                    [name]: +valueState,
                },
            });
        }
    };

    const actionValue = data[`${original?.id}`]?.action;

    const title: any = original?.[`${name}`];

    const varButtons: any = {
        1: { save: 'bg-primary text-white', cancel: 'bg-danger text-white' },
        0: { cancel: '', save: '' },
    };
    return (
        <div className={classNames(styles.actions)}>
            {actionValue ? (
                <div>
                    <AmountLogs key={idValue} logs={logs} />
                    <div style={{ display: 'flex' }}>
                        <div>
                            <input
                                value={`${valueState}`}
                                onChange={(event: any) => {
                                    event.preventDefault();
                                    setCheckValue(0);
                                    setValue(`${event.target.value}`);
                                }}
                                type="number"
                            />

                            <div style={{ display: 'block' }}>totalValueState: {total}</div>
                            <small className={'text-danger'}>{err}</small>
                        </div>

                        <div>
                            <button
                                className={`mr-3 w-100 ${varButtons[checkValue].save}`}
                                type={'button'}
                                onClick={() => handleSave()}
                            >
                                <FontAwesomeIcon icon={faCheck} />
                            </button>

                            <button
                                type={'button'}
                                className={` w-100 ${varButtons[checkValue].cancel}`}
                                onClick={() => setValue(idValue?.[`${name}`])}
                            >
                                <FontAwesomeIcon icon={faMinus} />
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    <AmountLogs logs={logs} />
                    <div>{title}</div>
                </div>
            )}
        </div>
    );
};

export default SeanceActionsColumn;
